import React, { useEffect, useState, useRef } from "react";
import { User, list } from "../lib/userLib";
import UserCard from "./userCard";

const UsersList = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [openMenuId, setOpenMenuId] = useState<string | null>(null);
  const menuRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersData = await list();
        setUsers(usersData);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  // Close menu if clicking outside
  useEffect(() => {
    if (!openMenuId) return;
    function handleClick(e: MouseEvent) {
      if (typeof openMenuId === "string") {
        const menuEl = menuRefs.current[openMenuId];
        if (menuEl && !menuEl.contains(e.target as Node)) {
          setOpenMenuId(null);
        }
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [openMenuId]);

  const refreshUsers = async () => {
    try {
      const usersData = await list();
      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  if (loading) {
    return <div className="text-gray-800 dark:text-white">Loading...</div>;
  }

  return (
    <div className="container mx-auto p-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 p-6 rounded-lg">
        {users.map((user) => (
          <UserCard
            key={user.id}
            user={user}
            inUserCollectionView={true}
            openMenuId={openMenuId}
            setOpenMenuId={setOpenMenuId}
            menuRefs={menuRefs}
            onUserDeleted={refreshUsers}
          />
        ))}
      </div>
    </div>
  );
};

export default UsersList;
